// Пример данных для вкладки «аналитика», пока у человека меньше двух дней
// с записями (решение владельца 27.10.2026): графики с тестовыми рядами и
// подсказки Зои показывают, что здесь будет. Ряды детерминированные —
// пример выглядит одинаково при каждом открытии. Форма объекта повторяет
// ответ GET /diary/summary?period=range ровно настолько, насколько его
// читают карточки Diary.vue; раскладок «из чего» и витаминов нет.

import { addDays } from './periodCharts.js'

const DAYS = 60

// Простой детерминированный генератор, чтобы не тянуть библиотеку
function rng(seed) {
  let s = seed >>> 0
  return () => { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296 }
}

/**
 * norms — { kcal, protein: [min,max], fat: [min,max], carbs: [min,max] }
 * (нормы человека, если они уже посчитаны, иначе средние).
 * yesterday — последний день примера, YYYY-MM-DD.
 */
export function demoPeriod(norms, yesterday) {
  const rand = rng(20261027)
  const kcal = norms?.kcal || 2000
  const protein = norms?.protein || [70, 100]
  const fat = norms?.fat || [55, 80]
  const carbs = norms?.carbs || [200, 280]
  const from = addDays(yesterday, -(DAYS - 1))
  const days = []
  const byDay = {}
  const satByDay = {}, freeByDay = {}
  // Четыре пропущенных дня — чёрточки на графике, как в живом дневнике
  const skipped = new Set([addDays(from, 9), addDays(from, 23), addDays(from, 24), addDays(from, 41)])
  for (let i = 0; i < DAYS; i++) {
    const day = addDays(from, i)
    if (skipped.has(day)) continue
    const weekend = [5, 6].includes((new Date(day + 'T00:00:00Z').getUTCDay() + 6) % 7)
    const k = Math.round(kcal * (0.82 + rand() * 0.28 + (weekend ? 0.12 : 0)))
    const p = Math.round(protein[0] * 0.75 + rand() * (protein[1] - protein[0] * 0.75))
    const f = Math.round(fat[0] * 0.8 + rand() * (fat[1] * 1.25 - fat[0] * 0.8))
    const c = Math.round(carbs[0] * 0.7 + rand() * (carbs[1] * 1.05 - carbs[0] * 0.7))
    const row = { day, kcal: k, protein: p, fat: f, carbs: c,
      fiber: Math.round((14 + rand() * 16) * 10) / 10, water: Math.round(1400 + rand() * 900) }
    days.push(row); byDay[day] = k
    satByDay[day] = { sat: Math.round((f * (0.28 + rand() * 0.14)) * 10) / 10 }
    freeByDay[day] = { free: Math.round((12 + rand() * 30 + (weekend ? 15 : 0)) * 10) / 10 }
  }
  const avg = (key) => Math.round(days.reduce((s, d) => s + d[key], 0) / days.length)
  const avg1 = (obj, key) => Math.round(Object.values(obj).reduce((s, v) => s + v[key], 0) / days.length * 10) / 10
  const periodData = {
    demo: true,
    period: { from, to: yesterday, display_to: yesterday },
    first_day: from,
    days_with_entries: days.map(d => d.day),
    days_tracked: days.length,
    sufficient: true,
    averages: { kcal: avg('kcal'), protein: avg('protein'), fat: avg('fat'), carbs: avg('carbs'),
      fiber: Math.round(days.reduce((s, d) => s + d.fiber, 0) / days.length * 10) / 10, water: avg('water'), vitamins: null },
    day_kcals: byDay,
    days,
    fats_breakdown: { sat: { avg_day: avg1(satByDay, 'sat'), approx: false }, by_day: satByDay },
    sugars_breakdown: { free: { avg_day: avg1(freeByDay, 'free'), approx: false }, by_day: freeByDay },
    kcal_breakdown: null, protein_breakdown: null, fat_breakdown: null, carbs_breakdown: null,
    fiber_breakdown: null, water_breakdown: null, planned_days: [], planned_kcals: {},
  }
  // Вес: замер через два-три дня, минус 300 г в неделю с шумом
  const weightPoints = []
  let kg = 74.6
  for (let i = 0; i < DAYS; i += 2 + Math.floor(rand() * 2)) {
    kg -= 0.3 / 7 * 2.5
    weightPoints.push({ day: addDays(from, i), kg: Math.round((kg + (rand() - 0.5) * 0.8) * 10) / 10 })
  }
  return { periodData, weightPoints }
}
